import { render, staticRenderFns } from "./company-settings.vue?vue&type=template&id=3f2e9f49&"
import script from "./company-settings.vue?vue&type=script&lang=js&"
export * from "./company-settings.vue?vue&type=script&lang=js&"
import style0 from "./company-settings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports